const miniAppSdkConfig = {
  alipay: 'https://appx/web-view.min.js',
  qq: 'https://qqq.gtimg.cn/miniprogram/webview_jssdk/qqjssdk-1.0.0.js',
  wx: 'https://res.wx.qq.com/open/js/jweixin-1.4.0.js',
  bytedance: 'https://lf3-cdn-tos.bytegoofy.com/obj/goofy/developer/jssdk/jssdk-1.2.1.js',
  baidu: 'https://b.bdstatic.com/searchbox/icms/searchbox/js/swan-2.0.31.js',
  quick: 'https://quickapp/jssdk.webview.min.js',
  wxAuthUrl:'/api/wechat/auth/js/token',
}

const msgQueue = {};
function onMessage({id, success, data}) {
  if (msgQueue[id]) {
    if (success) {
      msgQueue[id].success(...data);
    } else {
      msgQueue[id].fail(...data);
    }
    delete msgQueue[id];
  }
}

function postMessage({api, option, success, fail}) {
  let id = dsf.uuid(32);
  uni.postMessage({
    type: 'system',
    id,
    api,
    option
  });
  if (success || fail) {
    msgQueue[id] = {success, fail};
  }
}

const userAgent = window.navigator.userAgent;

function clientInfo(){
  if (!clientInfo.val) {
    clientInfo.val = dsf.client.miniAppType();
  }
  return clientInfo.val;
}

const api = {
  wx: {
    chooseImage(option) {
      return new Promise((resolve, reject) => {
        wx.chooseImage({
          ...option,
          success: async function (res) {
            try {
              let arr = [], base64List = await api.wx.localImgToBase64(res.localIds);
              for (let i = 0, l = base64List.length; i < l; i++) {
                let file = await createLocalImgFile(base64List[i]);
                arr.push(file);
              }
              resolve(arr);
            } catch (e) {
              reject(e)
            }
          },
          fail(err) {
            reject(err)
          }
        });
      });
    },
    previewImage(option) {
      wx.previewImage(option);
      return Promise.resolve();
    },
    scan(option) {
      return new Promise((resolve, reject) => {
        wx.scanQRCode({
          ...option,
          success(res) {
            res.result = res.resultStr;
            resolve(res);
          },
          fail(err) {
            reject(err)
          }
        });
      })
    },
    getLocation(option) {
      return new Promise((resolve, reject) => {
        wx.getLocation({
          ...option,
          success(res) {
            resolve(res);
          },
          fail(err) {
            reject(err)
          }
        });
      })
    },
    openLocation(option) {
      return new Promise((resolve, reject) => {
        wx.openLocation({
          ...option,
          success(res) {
            resolve(res);
          },
          fail(err) {
            reject(err)
          }
        });
      })
    },
    localImgToBase64(localIds) {
      return new Promise((resolve, reject) => {
        let fn = (i = 0, arr = []) => {
          if (i == localIds.length) {
            resolve(arr);
            return;
          }
          wx.getLocalImgData({
            localId: localIds[i],
            success: function (res) {
              arr.push(res.localData);
              fn(i + 1, arr);
            },
            error: function (err) {
              reject(err);
            }
          });
        }
        fn();
      });
    },
    navigateToMiniProgram(option) {
      uni.navigateTo({
        url: '/pages/api/api?' + dsf.url.serialize({
          api: 'navigateToMiniProgram',
          options: JSON.stringify([option])
        })
      });
      return Promise.resolve();
    }
  },
  baidu: {
    chooseImage(option) {
      return new Promise((resolve, reject) => {
        swan.chooseImage({
          ...option,
          success: function (res) {
            resolve(res);
          },
          fail(err) {
            reject(err)
          }
        });
      });
    },
    previewImage(option) {
      swan.previewImage(option);
      return Promise.resolve();
    },
    scan() {
      return Promise.reject({
        message: '当前环境内不支持扫码操作'
      });
    },
    getLocation(option) {
      return new Promise((resolve, reject) => {
        swan.getLocation({
          ...option,
          success(res) {
            resolve(res);
          },
          fail(err) {
            reject(err)
          }
        });
      })
    },
    openLocation(option) {
      return new Promise((resolve, reject) => {
        swan.openLocation({
          ...option,
          success(res) {
            resolve(res);
          },
          fail(err) {
            reject(err)
          }
        });
      })
    }
  },
  bytedance: {
    chooseImage(option) {
      return new Promise((resolve, reject) => {
        tt.miniProgram.chooseImage({
          ...option,
          success: function (res) {
            resolve(res);
          },
          fail(err) {
            reject(err)
          }
        });
      });
    },
    previewImage(option) {
      return new Promise((resolve, reject) => {
        tt.miniProgram.previewImage({
          ...option,
          success: function (res) {
            resolve(res);
          },
          fail(err) {
            reject(err)
          }
        });
      });
    },
    scan() {
      return Promise.reject({
        message: '当前环境不支持扫码操作'
      });
    },
    getLocation(option) {
      return new Promise((resolve, reject) => {
        tt.miniProgram.getLocation({
          ...option,
          success(res) {
            resolve(res);
          },
          fail(err) {
            reject(err)
          }
        });
      })
    },
    openLocation(option) {
      return new Promise((resolve, reject) => {
        tt.miniProgram.openLocation({
          ...option,
          success(res) {
            resolve(res);
          },
          fail(err) {
            reject(err)
          }
        });
      })
    }
  },
  alipay: {
    chooseImage(option) {
      return new Promise((resolve, reject) => {
        postMessage({
          api: 'chooseImage',
          option: [option],
          success: async function (base64List) {
            try {
              let arr = [];
              for (let i = 0, l = base64List.length; i < l; i++) {
                let file = await createLocalImgFile(base64List[i]);
                arr.push(file);
              }
              resolve(arr);
            } catch (e) {
              reject(e)
            }
          },
          fail(err) {
            reject(err)
          }
        });
      });
    },
    previewImage(option) {
      return new Promise(function (resolve, reject) {
        postMessage({
          api: 'previewImage',
          option: [option],
          success(res) {
            resolve(res);
          },
          fail(err) {
            reject(err)
          }
        });
      });
    },
    scan(option) {
      return new Promise(function (resolve, reject) {
        postMessage({
          api: 'scanCode',
          option: [option],
          success(res) {
            resolve(res);
          },
          fail(err) {
            reject(err)
          }
        });
      });
    },
    getLocation(option) {
      return new Promise(function (resolve, reject) {
        postMessage({
          api: 'getLocation',
          option: [option],
          success(res) {
            resolve(res);
          },
          fail(err) {
            reject(err)
          }
        });
      });
    },
    openLocation(option) {
      return new Promise((resolve, reject) => {
        postMessage({
          api: 'openLocation',
          option: [option],
          success(res) {
            resolve(res);
          },
          fail(err) {
            reject(err)
          }
        });
      });
    },
    setNavigationBarTitle(option) {
      return new Promise((resolve, reject) => {
        postMessage({
          api: 'setNavigationBarTitle',
          option: [option],
          success(res) {
            resolve(res);
          },
          fail(err) {
            reject(err)
          }
        });
      });
    },
    setNavigationBarColor(option) {
      return new Promise((resolve, reject) => {
        postMessage({
          api: 'setNavigationBarColor',
          option: [option],
          success(res) {
            resolve(res);
          },
          fail(err) {
            reject(err)
          }
        });
      });
    },
    makePhoneCall(option) {
      return new Promise((resolve, reject) => {
        postMessage({
          api: 'makePhoneCall',
          option: [option],
          success(res) {
            resolve(res);
          },
          fail(err) {
            reject(err)
          }
        });
      });
    },
    navigateToMiniProgram(option) {
      return new Promise((resolve, reject) => {
        postMessage({
          api: 'navigateToMiniProgram',
          option: [option],
          success(res) {
            resolve(res);
          },
          fail(err) {
            reject(err)
          }
        });
      });
    }
  },
  default: {
    chooseImage() {
      return Promise.reject({
        message: '当前环境不支持选择图片操作'
      });
    },
    previewImage() {
      return Promise.reject({
        message: '当前环境不支持预览图片操作'
      });
    },
    scan() {
      return Promise.reject({
        message: '当前环境不支持扫码操作'
      });
    },
    getLocation() {
      return Promise.reject({
        message: '当前环境不支持定位操作'
      });
    },
    openLocation() {
      return Promise.reject({
        message: '当前环境不支持调用内置地图操作'
      });
    },
    setNavigationBarTitle(option) {
      postMessage({
        api: 'setNavigationBarTitle',
        option: [option]
      });
      return Promise.resolve();
    },
    setNavigationBarColor(option) {
      postMessage({
        api: 'setNavigationBarColor',
        option: [option]
      });
      return Promise.resolve();
    },
    makePhoneCall(option) {
      let a = document.createElement('a');
      a.href = 'tel:' + (option.phoneNumber || '');
      document.body.append(a);
      a.click();
      document.body.removeChild(a);
      return Promise.resolve();
    },
    navigateToMiniProgram(option) {
      return Promise.reject({
        message: '当前环境不支持打开另一个小程序'
      });
    }
  },
};
function getApi(name) {
  return (api[clientInfo()]?.[name] || api['default'][name]);
}

function createLocalImgFile(src) {
  let type = Object.prototype.toString.call(src);
  if (type == "[object String]") {
    return new Promise((resolve, reject) => {
      let obj = new Image();
      obj.onload = async () => {
        try {
          let file = await createLocalImgFile(obj);
          resolve(file);
        } catch (err) {
          reject(err);
        }
      };
      obj.onerror = e => {
        reject(e);
      }
      obj.src = src.indexOf('data:image') == 0 ? src : ('data:image/jpeg;base64,' + src);
    });
  }
  if (type == "[object HTMLImageElement]") {
    return new Promise((resolve, reject) => {
      let {width, height} = src;
      const canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext("2d");
      ctx.fillStyle = "#fff";
      ctx.fillRect(0, 0, width, height);
      ctx.drawImage(src, 0, 0, width, height);
      try {
        canvas.toBlob(blob => {
          blob.name = dsf.uuid(32) + '.jpg';
          resolve(blob);
        }, 'image/jpeg', 0.8);
      } catch (e) {
        reject(e);
      }
    });
  }
  return Promise.reject(null);
}

/**
 * 获取微信签名
 * @param jsApiList
 * @returns {Promise<unknown>}
 */
function wxAuthToken(jsApiList) {
  return new Promise((resolve, reject) => {
    dsf.http.get(miniAppSdkConfig.wxAuthUrl, {
      url: window.encodeURIComponent(window.location.href)
    }).done((res) => {
      if (res.data.jsApiTicket) {
        wx.appId = res.data.appId;
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: res.data.appId, // 必填，公众号的唯一标识
          timestamp: res.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
          signature: res.data.signature, // 必填，签名
          jsApiList: jsApiList // 必填，需要使用的JS接口列表
        });
        wx.ready(function () {
          resolve(res.data)
        });
        wx.error(function (res) {
          reject(res)
        });
      } else {
        reject(false);
      }
    }).error((res) => {
      reject(res)
    })
  })
}

export default {
  type: "miniapp",
  isEnv() {
    return !!clientInfo();
  },
  init(a,b,opt) {
    try {
      if (!/toutiaomicroapp/i.test(userAgent)) {
        $('.post-message-section').css('visibility', 'visible');
      }
      return new Promise((resolve, reject) => {
        const sdkUrl = [];
        if (clientInfo()) {
          sdkUrl.push(
            miniAppSdkConfig[clientInfo()],
            dsf.url.getWebPath("$/js/libs/uni-app/uni.webview.1.5.4.js")
          );
        }
        // 加载sdk
        dsf.http.importFiles(sdkUrl).then(([{ state }]) => {
          if (!state) {
            console.error("小程序sdk加载出错")
            reject(`${miniAppSdkConfig[clientInfo()]}文件出错`);
            return;
          }
          setTimeout(() => {
            if (clientInfo() == 'alipay') {
              my.onMessage = onMessage;
            } else if (clientInfo() == 'wx') {
              miniAppSdkConfig.wxAuthUrl = opt?._wechat?.authUrl || miniAppSdkConfig.wxAuthUrl
              wxAuthToken(this.jsApiList);
            }
            let obj = dsf.url.parse(location.href);
            let {extDTO, cookie} = obj.searchQuery;
            if (cookie) {
              try {
                cookie = JSON.parse(cookie);
                _.each(cookie, (v, k) => {
                  dsf.session.set(k, v);
                });
                dsf.session.set('isLogin', 1);
              } catch (e) {
                // ignore
              }
            }
            if (extDTO) {
              try {
                extDTO = JSON.parse(extDTO);
              } catch (e) {
                // ignore
              }
            }
            extDTO = dsf.storage.session.get('extDTO', extDTO);
            let safeAreaInsets = dsf.storage.session.get('safeAreaInsets');
            dsf.storage.session.remove('extDTO');
            if (safeAreaInsets) {
              document.documentElement.style.setProperty('--safe-area-inset-bottom', safeAreaInsets.bottom + 'px');
              document.documentElement.style.setProperty('--safe-area-inset-top', safeAreaInsets.top + 'px');
            }
            if (extDTO) {
              resolve(extDTO);
            } else {
              resolve({});
            }
          });
        }).catch((err) => {
          reject(err);
        });
      });
    } catch (error) {
      return Promise.reject(error)
    }
  },
  jsApiList: [
    'updateAppMessageShareData',
    'updateTimelineShareData',
    'onMenuShareTimeline',
    'onMenuShareAppMessage',
    'onMenuShareQQ',
    'onMenuShareWeibo',
    'onMenuShareQZone',
    'startRecord',
    'stopRecord',
    'onVoiceRecordEnd',
    'playVoice',
    'pauseVoice',
    'stopVoice',
    'onVoicePlayEnd',
    'uploadVoice',
    'downloadVoice',
    'chooseImage',
    'previewImage',
    'uploadImage',
    'downloadImage',
    'translateVoice',
    'getNetworkType',
    'openLocation',
    'getLocation',
    'hideOptionMenu',
    'showOptionMenu',
    'hideMenuItems',
    'showMenuItems',
    'hideAllNonBaseMenuItem',
    'showAllNonBaseMenuItem',
    'closeWindow',
    'scanQRCode',
    'chooseWXPay',
    'openProductSpecificView',
    'addCard',
    'chooseCard',
    'openCard',
  ],
  methods: {
    setNavigationBarTitle(option) {
      return getApi('setNavigationBarTitle')(option);
    },
    setNavigationBarColor(option) {
      return getApi('setNavigationBarColor')(option);
    },
    /**
     * 选择图片
     * @param options.count 选择数量， 默认1
     * @param options.sizeType 可以指定是原图还是压缩图，默认二者都有
     * @param options.sourceType 可以指定来源是相册还是相机，默认二者都有
     * @returns {*}
     */
    chooseImage(options = {}) {
      options = Object.assign({
        count: 1,
        sizeType: ['original', 'compressed'],
        sourceType: ['album', 'camera'],
      }, options);
      return getApi('chooseImage')(options);
    },
    /**
     * 预览图片
     * @param options.current 当前显示图片的http链接
     * @param options.urls 需要预览的图片http链接列表
     * @returns {*}
     */
    previewImage(options = {}) {
      options = Object.assign({
        current: '',
        urls: []
      }, options);
      return getApi('previewImage')(options);
    },
    /**
     * 扫码
     * @param options.scanType 可以指定扫二维码还是一维码，默认二者都有
     * @returns {*}
     */
    scan(options = {}) {
      options = Object.assign({
        scanType: ["qrCode", "barCode"],
        needResult: 1 // 默认为1，直接返回扫描结果，0则扫描结果由微信处理
      }, options, {
      });
      return getApi('scan')(options);
    },
    /**
     * 获取地理位置接口
     * @param options.type 默认为wgs84的gps坐标
     */
    getLocation(options = {}) {
      options = Object.assign({
        type: 'wgs84'
      }, options);
      return getApi('getLocation')(options);
    },
    /**
     * 使用应用内置地图查看位置
     * @param options.latitude 纬度，浮点数，范围为90 ~ -90
     * @param options.longitude 经度，浮点数，范围为180 ~ -180
     * @param options.name 位置名
     * @param options.address 地址详情说明
     * @param options.scale 地图缩放级别,整型值,范围从1~28。默认为最大
     */
    openLocation(options = {}) {
      options = Object.assign({
        latitude: 0,
        longitude: 0,
        scale: 18,
        name: '',
        address: ''
      }, options);
      getApi('openLocation')(options);
    },
    /**
     * 拨打电话
     * @param options
     * @param options.phoneNumber {string} 手机号码
     */
    callPhone(options) {
      this.makePhoneCall(options);
    },
    /**
     * 拨打电话
     * @param options
     * @param options.phoneNumber {string} 手机号码
     */
    makePhoneCall(options = {}) {
      options = Object.assign({
        phoneNumber: ''
      }, options);
      getApi('makePhoneCall')(options);
    },
    /**
     * 打开另一个小程序
     * @param options {Object}
     * @param options.appId {String} 要打开的小程序 appId
     * @param options.path {String} 打开的页面路径，如果为空则打开首页
     * @param options.extraData {Object} 需要传递给目标小程序的数据
     * @param options.envVersion {String} 	要打开的小程序版本：develop(开发版)、trial(体验版)、release(正式版)。仅在当前小程序为开发版或体验版时此参数有效。如果当前小程序是正式版，则打开的小程序必定是正式版。
     */
    navigateToMiniProgram(options = {}) {
      let appId = options.appId;
      if (!appId) {
        return Promise.reject('appId不能为空');
      }
      appId = appId.split('.');
      if (clientInfo() == 'alipay') {
        appId = _.find(appId, s => /^\d{16}$/.test(s));
      } else if (clientInfo() == 'wx') {
        appId = _.find(appId, s => /^wx[\d\w]{16}$/.test(s));
      } else {
        appId = null;
      }
      if (!appId) {
        return Promise.reject('appId不能为空');
      }
      options = Object.assign({
        path: '',
        extraData: {},
        envVersion: 'release'
      }, options, {appId});
      return getApi('navigateToMiniProgram')(options);
    }
  }
}
